import(/* webpackMode: "eager", webpackExports: ["Work"] */ "/app/next/src/components/pages/Work/Work.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
